module.exports = __webpack_public_path__ + "images/questions/qa_best_awnser_tag_d5c747f5211a24c95730882395f2d072.png";